import React from "react";
import StatusFlowbar from "@/components/layout/StatusFlowbar";

interface AdminAppStatusFlowbarProps {
  borrowerId: number;
  hideBadge?: boolean;
}

export const AdminAppStatusFlowbar: React.FC<AdminAppStatusFlowbarProps> = ({
  borrowerId,
  hideBadge,
}) => <StatusFlowbar borrowerId={borrowerId} editable hideBadge={hideBadge} />;
